import React, { useContext, useMemo } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { AsideWidgets } from "@features/side-widgets";
import { ErrorPage } from "@components-shared/desktop/error";
import EventPage from "@features/offer/desktop/pages/event/EventPage";
import { LiveEventSideMenu } from "@features/offer/desktop/sidemenu";
import { useRootAppStore } from "@hooks";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";
import { LiveOfferMenuStore } from "@state/stores/offer/live/LiveOfferMenuStore";
import LiveEventMenuViewStore from "@state/stores/offer/live/LiveEventMenuViewStore";
import { HeaderType } from "@data-types/layout/headerTypeEnum";
import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";

export default observer(function LiveEventRouteLayout(props: {
	liveOfferMenuStore: LiveOfferMenuStore;
}) {
	//#region eventViewStore
	// TODO this should be moved to EventPage
	const offerStore = useRootAppStore();
	const { isSideMenuExpanded } = offerStore;
	const favoriteStore = useContext(FavoritesStoreContext);

	const liveEventMenuViewStore = useMemo(
		() =>
			new LiveEventMenuViewStore(
				offerStore,
				props.liveOfferMenuStore,
				favoriteStore
			),
		[]
	);

	//#region eventViewStore

	//#region css class

	const mainClassNames = classNames("l--main", {
		"sidebar-left-expanded": isSideMenuExpanded,
		"sidebar-left-collapsed": !isSideMenuExpanded,
	});

	const contentClassNames = classNames("l--content is-event", {
		"sidebar-left-expanded": isSideMenuExpanded,
		"sidebar-left-collapsed": !isSideMenuExpanded,
	});

	const footerClassNames = classNames("l--footer", {
		"sidebar-left-expanded": isSideMenuExpanded,
	});

	const asideClassNames = classNames("l--aside--left", {
		"is-expanded": isSideMenuExpanded,
	});

	//#endregion css class

	return (
		<DesktopLayout
			headerType={HeaderType.WITH_SIDEBAR}
			mainClassName={mainClassNames}
			footerClassName={footerClassNames}
		>
			<LiveEventSideMenuContext.Provider value={liveEventMenuViewStore}>
				<aside className={asideClassNames}>
					<LiveEventSideMenu />
				</aside>

				<section className={contentClassNames}>
					<ErrorPage>
						<EventPage
							liveOfferMenuStore={props.liveOfferMenuStore}
						/>
					</ErrorPage>
				</section>
			</LiveEventSideMenuContext.Provider>

			<AsideWidgets />
		</DesktopLayout>
	);
});
